import React from 'react';
import '../components/commonLoader.scss';

const CommonLoader = () => {
    return (
        <div className="loader-inner-container">
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default CommonLoader;
